import { GetTimelineResponse } from '../infrastructure/api-egg'
import { useQueryClient } from '@tanstack/react-query'
import { useToken } from './useToken'
import { setUserPresent } from '../infrastructure/api-present'
import { useCallback } from 'react'

export const useActions = () => {
    const queryClient = useQueryClient()
    const { _id } = useToken()

    const actionDispatcher = useCallback(
        ({ event, payload }: ActionsTypes) => {
            process.env.NODE_ENV === 'development' && console.log({ event, payload })
            // if has payload and scope does not include 'app', return
            if (payload && 'scope' in payload && payload?.scope?.length && !payload.scope?.includes('app')) return
            try {
                switch (event) {
                    case 'ui-user-has-update': {
                        queryClient.invalidateQueries({ queryKey: ['User', payload.userId] })
                        queryClient.invalidateQueries({ queryKey: ['Ranking'], exact: false })
                        return
                    }
                    case 'ui-team-has-updated': {
                        const courseId = payload?.courseId

                        // Set present when teams has been assigned if required
                        if (courseId && sessionStorage.getItem(`require-present-${courseId}`)) setUserPresent(courseId)

                        return
                    }

                    case 'ui-content-has-updated': {
                        queryClient.invalidateQueries({
                            queryKey: ['Study Plan', payload.courseId],
                            exact: false,
                        })
                        return
                    }

                    case 'new-timeline-event': {
                        const { _courseId } = payload
                        queryClient.setQueryData(['Team', 'Timeline', _courseId], payload)
                        return
                    }

                    case 'ui-reload': {
                        window.location.reload()
                        return
                    }

                    case 'user-joined': {
                        return
                    }

                    case 'ui-certificate-has-updated': {
                        const { userId } = payload
                        queryClient.invalidateQueries({ queryKey: ['User', userId, 'Certificates'] })
                        return
                    }

                    default:
                        console.warn('❗ Action not found:', { type: event, payload })
                        return
                }
            } catch (error) {
                console.error('❗ Error in actionDispatcher:', { type: event, payload, error })
            }
        },
        [queryClient, _id]
    )
    return { actionDispatcher }
}

type ActionsTypes =
    | {
          event: 'ui-user-has-update'
          payload: {
              userId: string
          }
      }
    | {
          event: 'ui-team-has-updated'
          payload?: {
              scope?: string[]
              courseId: string
              name: string
              _algorithmId?: string
          }
      }
    | {
          event: 'ui-content-has-updated'
          payload: {
              scope?: string[]
              courseId: string
          }
      }
    | {
          event: 'new-timeline-event'
          payload: GetTimelineResponse['data']
      }
    | {
          event: 'ui-reload'
          payload?: undefined
      }
    | {
          event: 'user-joined'
          payload: {
              scope?: string[]
              _id: string
              _profileId: string
          }
      }
    | {
          event: 'ui-certificate-has-updated'
          payload: {
              userId: string
          }
      }
